module.exports = __webpack_public_path__ + "img/s2P3.bc7d63b5.png";